import { Injectable, inject } from '@angular/core'
import { RestClientList } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Facility } from './facility'

@Injectable({
  providedIn: 'root',
})
export class FacilityService extends RestClientList<Facility, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)
    super(environment.apiPath + '/facilities', http)
  }
}
